export enum ERR {
    missingGitHubConfig = 'Please authenticate to use GitHub api',
}
